import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant';
import 'vant/lib/index.css';
import TrackMixin from './mixins/trackMixin';

Vue.config.productionTip = false;

// 使用插件
Vue.use(Vant);

Vue.mixin(TrackMixin);

new Vue({
  router,
  render: function (h) { return h(App) }
}).$mount('#app')
